import { Record } from 'immutable';
import { AssetTransfers } from 'records/AssetTransfer';

const defaultValues = {
    successAlert: false,
    failureAlert: false,
    loading: false,
    errorMessage: null,
    data: new AssetTransfers(),
};

export default class AssetTransferBase extends Record(defaultValues, AssetTransferBase) {
    constructor(values) {
        super({
            ...values,
        });
    }
}
